module.exports = __webpack_public_path__ + "img/choice_dn_rt.6ab7c673.png";